var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRepeatedRequests(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.1309 19.4761C26.7469 19.4761 26.4352 19.7877 26.4352 20.1717C26.4352 21.3223 25.4989 22.2587 24.3483 22.2587H7.65255C6.50194 22.2587 5.56559 21.3223 5.56559 20.1717V10.7205L8.55134 13.7077C8.82404 13.979 9.26369 13.979 9.53639 13.7077C9.8077 13.435 9.8077 12.9953 9.53639 12.7226L5.36385 8.55009C5.10228 8.28018 4.63759 8.28018 4.37602 8.55009L0.203479 12.7226C-0.0678264 12.9953 -0.0678264 13.435 0.203479 13.7077C0.476176 13.979 0.91583 13.979 1.18853 13.7077L4.17428 10.7205V20.1717C4.17428 22.0903 5.73533 23.65 7.65255 23.65H24.3483C26.2655 23.65 27.8266 22.0903 27.8266 20.1717C27.8266 19.7877 27.5149 19.4761 27.1309 19.4761Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.8138 9.94035L27.8281 12.9261V3.47632C27.8281 1.55771 26.267 -0.00195312 24.3498 -0.00195312H7.65406C5.73544 -0.00195312 4.17578 1.55771 4.17578 3.47632C4.17578 3.86032 4.48604 4.17198 4.87144 4.17198C5.25544 4.17198 5.56709 3.86032 5.56709 3.47632C5.56709 2.32432 6.50205 1.38936 7.65406 1.38936H24.3498C25.5004 1.38936 26.4368 2.32432 26.4368 3.47632V12.9261L23.4496 9.94035C23.1783 9.66905 22.7373 9.66905 22.466 9.94035C22.1946 10.2117 22.1946 10.6527 22.466 10.924L26.6385 15.0965C26.8973 15.3679 27.3661 15.3679 27.6249 15.0965L31.7975 10.924C32.0688 10.6527 32.0688 10.2117 31.7975 9.94035C31.5262 9.66905 31.0851 9.66905 30.8138 9.94035Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRepeatedRequests);
export default __webpack_public_path__ + "static/media/repeated-requests.5c1ae23043dc708ddc7c992cee28a9af.svg";
export { ForwardRef as ReactComponent };